import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function TotalProductsV2(props = {}, childrenComponents) {
	return {
		componentName: 'TotalProductsV2',
		componentId: uuidv4(),
		props: _.merge({}, props),
		childrenComponents,
	};
}
